<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">Clientes</h4>
          <router-link to="/app/sales/customer">
            <l-button wide type="primary" round>
              <span class="btn-label">
                <i class="fa fa-plus"></i>
              </span>
              Criar
            </l-button>
          </router-link>
          <!-- <p class="card-category">Here is a subtitle for this table</p> -->
        </div>
        <div class="x-page-links">
          <el-input
            v-model="search"
            prefix-icon="el-icon-search"
            style="width: 250px"
            placeholder="Digite para pesquisar"/>
        </div>
        <div class="table-responsive table-full-width">
          <el-table class="table-striped" :data="tableData.filter(data => !search || 
            data.nickname.toLowerCase().includes(search.toLowerCase()) ||
            data.email.toLowerCase().includes(search.toLowerCase()))">
            <el-table-column label="Nome" min-width="250" prop="fullName" sortable>
            </el-table-column>
            <el-table-column v-if="showItem" label="Empresa" 
                              property="company.profile__company__name" min-width="180"/>
            <el-table-column label="Apelido" property="nickname" width="220" sortable/>
            <el-table-column label="Email" property="email" width="340" sortable/>
            <el-table-column label="Ações">
              <div class="td-actions" slot-scope="props">
                <a
                  v-tooltip.top-center="'Edit Profile'"
                  class="btn btn-warning btn-link btn-xs"
                  @click="handleEdit(props.$index, props.row)"
                >
                  <i class="fa fa-edit"></i>
                </a>
                <a
                  v-tooltip.top-center="'Delete'"
                  class="btn btn-danger btn-link btn-xs"
                  @click="handleDelete(props.$index, props.row)"
                >
                  <i class="fa fa-close"></i>
                </a>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      companyList: [],
      search: ''
    };
  },
  computed: {
    tableData() {
      const customers = this.$store.state.customers.customers
      const populated = customers.map(v => {
        let company , fullName, nickname

        if (v.company) {
          company = this.companyList.find(e => e.profile__company__id == v.company);
        }
        if (v.first_name) {
          fullName = v.first_name + ' ' + v.last_name
        }
        if (v.nickname === null) {
          nickname = ''
        } 
        if (v.nickname) {
          nickname = v.nickname
        }
        return { ...v, company, fullName, nickname };
      })
      return populated
    },
    showItem() {
      const imach = localStorage.getItem("imach")
      if (imach === 'true') {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    this.getListCompany()
    this.$store.dispatch("customers/list").catch(err => console.log(err))
    // setInterval(function() {
    //   window.location.reload()
    // }, this.$store.state.general.timer)
  },
  methods: {
    handleEdit(i, row) {
      console.log(row);
      this.$router.push(`/app/sales/customer/${row.id}`);
    },
    getListCompany () {
      this.$store.dispatch('general/listUser').then(()=> {
        var x = this.$store.state.general.listUser.user_list_info
        this.companyList = x.filter((thing, index, self) =>
          index === self.findIndex((t) => (
            t.profile__company__id === thing.profile__company__id && t.profile__company__name === thing.profile__company__name
          ))
        )
      })
    },
    handleDelete(i, row) {
      console.log(row);
      const itemName = "Cliente";
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a excluir esse(a) ${itemName}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, exclua!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("customers/delete", { id: row.id });
          swal.fire({
            title: "Pronto!",
            text: `${itemName} excluído(a).`,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `${itemName} não excluído(a).`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
.card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
}
</style>
